export default "__VITE_ASSET__BWVKozKO__";